import { VETLINES_REPRESENTATIVE } from "../../constants";

export default function VetlinesRepresentative() {
    return (
        <div className="sm:py-12 py-6 border-b border-neutral-300 sm:px-16 px-6">
            <div className="flex md:flex-row flex-col-reverse gap-8 items-center">
                <div className="flex-1 text-center md:text-left">
                    <h3 className="text-emerald-500 font-poppins font-semibold text-sm uppercase tracking-wide">
                        {VETLINES_REPRESENTATIVE.brand} · {VETLINES_REPRESENTATIVE.country}
                    </h3>
                    <h2 className="font-poppins font-bold md:text-[32px] xs:text-[24px] text-[20px] mt-2">
                        {VETLINES_REPRESENTATIVE.title}
                    </h2>
                    <p className="mt-4 text-neutral-700">
                        {VETLINES_REPRESENTATIVE.description}
                    </p>

                    <a
                        href={VETLINES_REPRESENTATIVE.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-4 text-emerald-600 font-poppins font-semibold hover:underline"
                    >
                        Visit vetlines.pl →
                    </a>
                </div>

                <div className="flex justify-center items-center">
                    <img
                        src={VETLINES_REPRESENTATIVE.image}
                        alt={VETLINES_REPRESENTATIVE.brand}
                        className="rounded-2xl object-contain max-w-[400px] max-h-[400px] w-auto h-auto"
                    />
                </div>
            </div>
        </div>
    );
}